import { Link } from "gatsby"
// import PropTypes from "prop-types"
import React from "react"
import { inject, observer } from "mobx-react"
import { action } from "mobx"
// import {TransitionPortal} from 'gatsby-plugin-transition-link'
import { gsap } from "gsap"

import * as css from "@css/components/header.module.styl"
import SvgLogo from "@images/global__lbl__logo.svg"
import MenuList from "@components/MenuList"
// import { Link } from 'gatsby'

@inject("store")
@observer
class Header extends React.Component {
  constructor(props) {
    super(props)
    this.logoRef = React.createRef()
  }
  componentDidMount() {
    this.handleResize()
    window.addEventListener("resize", this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize = action(() => {
    const { store } = this.props
    const { UserAgentStore } = store
    if (window.innerWidth < 768) {
      UserAgentStore.isMobile = true
    } else {
      UserAgentStore.isMobile = false
    }
  })
  render() {
    const { store, location } = this.props
    const { UserAgentStore } = store
    if (this.logoRef.current) {
      if (UserAgentStore.isModal) {
        gsap.to(this.logoRef.current, {
          duration: 0.6,
          opacity: 0,
        })
      } else {
        gsap.to(this.logoRef.current, {
          duration: 0.6,
          opacity: 1,
        })
      }
    }
    return (
      <header className={css.header}>
        <div className={css.container}>
          <nav className={css.navi}>
            <ul className={css.list_left}>
              <li className={`${css.item} ${css.logo}`} ref={this.logoRef}>
                <Link to="/" direction="back">
                  <SvgLogo />
                </Link>
              </li>
            </ul>
            {UserAgentStore.isMobile ? null : (
              <MenuList css={css} location={location} />
            )}
          </nav>
        </div>
      </header>
    )
  }
}
// Header.propTypes = {
//  siteTitle: PropTypes.string,
// }

// Header.defaultProps = {
//  siteTitle: ``,
// }

export default Header
